// Module
var code = "<ngx-go-banner ng-repeat=\"banner in $ctrl.banners\" [banner]=\"banner\" (on-close)=\"$ctrl.removeBanner(banner)\"></ngx-go-banner>";
// Exports
module.exports = code;